import { render } from "./CoReg_Co_Edit.vue?vue&type=template&id=2df08ceb&scoped=true"
import script from "./CoReg_Co_Edit.vue?vue&type=script&lang=js"
export * from "./CoReg_Co_Edit.vue?vue&type=script&lang=js"

import "./CoReg_Co_Edit.vue?vue&type=style&index=0&id=2df08ceb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df08ceb"]])

export default __exports__